import { oncallFetch } from "sc/backend/oncall/fetch-helper";

export default function*(username, password) {
  return yield oncallFetch("/api/oncall/administration/users/change-password", {
    username,
    password,
  });
}



// WEBPACK FOOTER //
// ./src/sc/backend/oncall/administration/users/change-password.js